import { render, staticRenderFns } from "./ProductDetailModuleDetailView.vue?vue&type=template&id=e4ea4e02&scoped=true"
import script from "./ProductDetailModuleDetailView.vue?vue&type=script&lang=js"
export * from "./ProductDetailModuleDetailView.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailModuleDetailView.vue?vue&type=style&index=0&id=e4ea4e02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ea4e02",
  null
  
)

export default component.exports